(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MainDashboardController', MainDashboardController);

    MainDashboardController.$inject = ['__config', '$scope', '$state', '$interval', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', 'CompanyInfoQuery', 'ServiceItemCustom', '$translatePartialLoader', '$translate', 'ServiceCategoryCustom', 'OrderBagServiceItemCustom', 'NewsCustom'];

    function MainDashboardController(__config, $scope, $state, $interval, ParseLinks, AlertService, CompanyCustomerCustom, CompanyInfoQuery, ServiceItemCustom, translatePartialLoader, translate, ServiceCategoryCustom, OrderBagServiceItemCustom, NewsCustom) {
        var vm = this;

        vm.loadPage = loadPage;
        // vm.nextReserveNumber_Func = nextReserveNumber_Func;
        vm.lengthChecker = lengthChecker;
        vm.fadingNumbers = fadingNumbers;

        vm.gotoNewReserve = gotoNewReserve;
        vm.gotoWebSite = gotoWebSite;

        vm.companyInfoStatus = false;
        vm.companyWorkingTimeStatus = false;
        vm.companySettingStatus = false;
        vm.initialCheck = null;
        vm.lastWeekReserveNumber = 0;
        vm.lastMonthReserveNumber = 0;
        vm.nextReserveNumber = 0;
        vm.tomorrowReserveCount = 0;
        vm.totalReservesNumber = 0;
        vm.numberOfReservesTitlesCompleted = 0;
        vm.time = 0;
        vm.timeNew = '';
        vm.tomorrowPeopleCount = 0;
        vm.appMode = __config.appMode;
        vm.goToEventState = goToEventState;
        vm.slideIndex = 0;
        vm.showSlides = showSlides;
        vm.getNewsTagClass = getNewsTagClass;
        vm.openNewsUrl = openNewsUrl;
        vm.prevNews = prevNews;
        vm.nextNews = nextNews;

///////////////Numbers Start//////////

        OrderBagServiceItemCustom.getReserveStats().query(function (reserve) {

            vm.tomorrowPeopleCount = reserve.tomorrowPeopleCount;

            setTimeout(function () {
                $("#analogClock_container").animate({left: "0"});
            }, 1000);

            lengthChecker(reserve.weeklyReserveCount);
            if (reserve.weeklyReserveCount !== 0) {
                if (reserve.weeklyReserveCount > 10)
                    vm.lastWeekReserveNumber += reserve.weeklyReserveCount - 10;
                var setInterval = $interval(function myTimer() {


                    if (vm.lastWeekReserveNumber === reserve.weeklyReserveCount) {
                        vm.numberOfReservesTitlesCompleted += 1;
                        fadingNumbers();
                        $interval.cancel(setInterval);
                    }

                }, vm.time);
            } else {
                vm.numberOfReservesTitlesCompleted += 1;
            }
//////------------

            lengthChecker(reserve.monthlyReserveCount);

            if (reserve.monthlyReserveCount !== 0) {
                if (reserve.monthlyReserveCount > 10)
                    vm.lastMonthReserveNumber = reserve.monthlyReserveCount - 10;
                var setInterval2 = $interval(function myTimer() {
                    vm.lastMonthReserveNumber += 1;
                    if (vm.lastMonthReserveNumber === reserve.monthlyReserveCount) {
                        vm.numberOfReservesTitlesCompleted += 1;
                        fadingNumbers();
                        $interval.cancel(setInterval2);
                    }

                }, vm.time);
            } else {
                vm.numberOfReservesTitlesCompleted += 1;
            }
//////----------

            lengthChecker(reserve.totalReserveCount);
            if (reserve.totalReserveCount !== 0) {
                if (reserve.totalReserveCount > 10)
                    vm.totalReservesNumber = reserve.totalReserveCount - 10;
                var setInterval3 = $interval(function myTimer() {

                    vm.totalReservesNumber += 1;
                    if (vm.totalReservesNumber === reserve.totalReserveCount) {
                        vm.numberOfReservesTitlesCompleted += 1;
                        fadingNumbers();
                        $interval.cancel(setInterval3);
                    }

                }, vm.time);
            } else {
                vm.numberOfReservesTitlesCompleted += 1;
            }
//////----------

            // lengthChecker(reserve.totalReserveCount);
            // if(reserve.activeReserveCount !== 0) {
            //     if(reserve.activeReserveCount>10)
            //         vm.nextReserveNumber = reserve.activeReserveCount-10;
            //     var setInterval4 = $interval(function myTimer() {
            //
            //         vm.nextReserveNumber += 1;
            //         if (vm.nextReserveNumber === reserve.activeReserveCount) {
            //             vm.numberOfReservesTitlesCompleted += 1;
            //             fadingNumbers();
            //             $interval.cancel(setInterval4);
            //         }
            //
            //     }, vm.time);
            // } else {
            //     vm.numberOfReservesTitlesCompleted += 1;
            // }


//////----------

            lengthChecker(reserve.tomorrowReserveCount);
            if (reserve.tomorrowReserveCount !== 0) {
                if (reserve.tomorrowReserveCount > 10)
                    vm.tomorrowReserveCount = reserve.tomorrowReserveCount - 10;
                var setInterval5 = $interval(function myTimer() {

                    vm.tomorrowReserveCount += 1;
                    if (vm.tomorrowReserveCount === reserve.tomorrowReserveCount) {
                        vm.numberOfReservesTitlesCompleted += 1;
                        fadingNumbers();
                        $interval.cancel(setInterval5);
                    }

                }, vm.time);
            } else {
                vm.numberOfReservesTitlesCompleted += 1;
            }


        });
///////////////Numbers End//////////


        loadAll();


        function loadAll() {

            vm.orderBagServiceItems = [];

            var filter = {};

            filter.maxResult = 10;
            OrderBagServiceItemCustom.searchOrderBagItemsByQuery().save(filter, function (data) {
                vm.orderBagServiceItems = data;

            });


            loadCompanyInfo();
            isCompanyInfoCompleted();
            getActiveNews();
            $interval(showSlides, 30000); // Change image every 20 seconds
        }

        function loadPage(page) {
        }

        function loadCompanyInfo() {
            CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {

                if (company != null && company != undefined) {
                    vm.company = company;
                    if (vm.company && vm.company.keyUrl)
                        vm.websiteUrl = vm.company.keyUrl + '.reserweb.ir';
                    else
                        vm.websiteUrl = '----------------' + '.reserweb.ir';


                } else {
                    vm.websiteUrl = '----------------' + '.reserweb.ir';
                }

            })
        }

        function gotoWebSite() {
            if (vm.company && vm.company.keyUrl) {

                window.open('http://' + vm.websiteUrl, '_blank');
            } else {
                alert('اطلاعات کسب و کار بطور کامل وارد نشده است (قدم اول را انجام دهید)');
            }
        }

        function gotoNewReserve(customerId) {

            var url = $state.href('supplierPanel.orderBagWithCustomerParameter', {
                customerId: customerId
            });

            window.open(url, '_blank');

        }

        function isCompanyInfoCompleted() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (company) {

                    if (company != undefined && company != null) {
                        if (company.title != null && company.title != "" && company.phoneNumber != null && company.phoneNumber != "")
                            vm.companyInfoStatus = true;
                        else
                            vm.companyInfoStatus = false;


                        if (company.setting != undefined && company.setting != null && company.setting.id != null && company.setting.id != undefined)
                            vm.companySettingStatus = true;
                        else
                            vm.companySettingStatus = false;


                    }
                }
            )


        }

        function lengthChecker(num) {
            if (num > 0 && num <= 10) {
                vm.time = 100;
            } else if (num > 10 && num <= 100) {
                vm.time = 20
            } else if (num > 100 && num <= 200) {
                vm.time = 15
            } else if (num > 200 && num <= 500) {
                vm.time = 10
            } else if (num > 500 && num <= 1000) {
                vm.time = 5
            } else if (num > 1000) {
                vm.time = 1
            }
        }

        function fadingNumbers() {
            if (vm.numberOfReservesTitlesCompleted === 4) {
                for (var i = 1; i <= 6; i++) {
                    $('#lastWeekReserveNumber').fadeToggle();
                    $('#lastMonthReserveNumber').fadeToggle();
                    $('#totalReservesNumber').fadeToggle();
                    // $('#nextReserveNumber').fadeToggle();
                    $('#tomorrowReserveNumber').fadeToggle();
                }
            }
        }

        function goToEventState(type) {
            $state.go('supplierPanel.newGeneralEventItem', {
                onlineMeetingType: type
            });
        }

        function getActiveNews() {
            NewsCustom.getActiveNewsByCurrentCompany().query().$promise.then(function (news) {

                    if (news) {
                        vm.news = news;
                        if (vm.news.length > 0) {
                            var i = 0;
                            angular.forEach(vm.news, function (newsItem) {

                                newsItem.index = i;
                                i++

                            });

                            vm.activeNews = vm.news[0];
                            // showSlides();
                        }
                    }

                }
            );
        }


        function showSlides() {
            vm.slideIndex++;
            if (vm.slideIndex == vm.news.length) {
                vm.slideIndex = 0
            }
            // vm.activeNews = vm.news[vm.slideIndex];

            angular.forEach(vm.news, function (item) {
                if (item.index == vm.slideIndex) {
                    item.cssClass = 'show-slide'
                    vm.activeNews = item;
                } else {
                    item.cssClass = 'hide-slide'
                }
            });


        }

        function getNewsTagClass() {
            if (vm.activeNews && vm.activeNews.newsType) {
                switch (vm.activeNews.newsType) {
                    case 'INFO':
                        return 'news-INFO';
                    case 'HELP':
                        return 'news-HELP';
                    case 'WARNING':
                        return 'news-WARNING';
                    case 'EXPERT_HELP':
                        return 'news-EXPERT_HELP';
                    case 'NEW_FEATURE':
                        return 'news-NEW_FEATURE';
                    case 'SPECIAL_OFFER':
                        return 'news-SPECIAL_OFFER';

                }
            }
        }

        function openNewsUrl() {
            if (vm.activeNews && vm.activeNews.actionUrl) {
                window.open(vm.activeNews.actionUrl, '_blank');
            }

        }

        function prevNews() {
            vm.slideIndex--;
            if (vm.slideIndex == -1 && vm.news && vm.news.length > 0) {
                vm.slideIndex = vm.news.length - 1;
            }
            vm.slideIndex--;
            showSlides();
        }

        function nextNews() {
            vm.slideIndex++;
            if (vm.news && vm.news.length == vm.slideIndex) {
                vm.slideIndex = 0;
            }

            showSlides();
        }

    }
})();


